// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indent {\n  margin-left: 1.5em;\n}\n.indent-two {\n  margin-left: 3em;\n}\n.setting-checkbox {\n  font-size: 1em !important;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  line-height: 2.3 !important;\n}\n.kanban-stage-container {\n  border: 1px solid var(--form-control-border);\n  border-radius: 4px;\n  margin: 10px 0;\n  padding: 5px 5px 0 5px;\n}\n.kanban-stage-name {\n  text-align: center;\n  margin-bottom: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
